export const productNames = {
  dmp: "DynaMed",
  dmx: "DynaMedex",
};

export const proxyTargets = {
  dmp: "https://www.dmp.eis-deliverydevqa.cloud",
  dmx: "https://www.dmx.eis-deliverydevqa.cloud",
};
